module.exports = __webpack_public_path__ + "a87f7a7912f34c8ed5580c67843693de.pdf";